<template>
  <div v-if="exhibits.length > 0">
    <hr class="w-full pb-26 border-gray"/>
    <div class="container mb-16 px-18">
      <h3 class="font-bold text-22">{{ exhibits.length > 1  ? "Ongoing Exhibits" : "Ongoing Exhibit" }}</h3>
    </div>
    <group-swiper-carousel :mobile-items="1"
                           :tablet-items="2"
                           :desktop-items="1">
      <template #slide>
        <swiper-slide v-for="(exhibit, key) in exhibits.slice(0, 3)" :key="key" v-if="exhibit.status === 'Ongoing'">
          <the-ongoing-exhibit-panel :exhibit="exhibit"/>
        </swiper-slide>
      </template>
    </group-swiper-carousel>
  </div>
</template>

<script>
import TheGalleryExhibitGird from "./Mixins/TheGalleryExhibitGird";
import GroupSwiperCarousel from "../../Universal/Carousel/GroupSwiperCarousel.vue";

export default {
  name: "TheGalleryMobileExhibitGrid",
  components: {GroupSwiperCarousel},

  mixins: [TheGalleryExhibitGird],
}
</script>
